<template>
  <ServicePageLayout
    title="Maintenance"
    subtitle="รายงานสถานะอุปกรณ์ปิดปรับปรุง"
    icon="mdi-volume-off"
    icon-color="secondary"
    breadcrumb="Operations"
  >
    <v-card flat class="service-content-panel">
      <v-card-text><DataTable /></v-card-text>
    </v-card>
  </ServicePageLayout>
</template>

<script>
import ServicePageLayout from '@/components/layout/ServicePageLayout.vue'
import DataTable from '@/components/maintenance/maintenance_table.vue'

export default {
  name: 'MaintenanceStatusView',
  components: {
    ServicePageLayout,
    DataTable,
  },
}
</script>
